import React from "react"
import Grail from 'elements/Grail'
import SearchBox from './SearchBox'
import NewsList from './NewsList'
import NewsContent from './NewsContent'
import styles from './news.scss'
import i18n from 'lib/i18n'
import cs from 'classnames'
const _ = i18n('news')

const NewsPageDom = ({ setFilter, filter, onOpen, newsToOpen, newsPosition, list, lang, isPhone, opened, isTablet }) => {

	return (
		<Grail
			nav={((!isPhone && !isTablet) || !newsToOpen) &&
				<Grail
					className={styles.leftColumn}
					header={
						<SearchBox
							filter={filter}
							filterTitle={_('filter')}
							moduleName={'news'}
							setFilter={setFilter}
							title={_('title')}
						/>
					}
					content={
						<NewsList
							lang={lang}
							list={list}
							newsPosition={newsPosition}
							noResults={_('emptySearch')}
							onOpen={onOpen}
							filter={filter}
							isPhone={isPhone}
							isTablet={isTablet}
						/>
					}
					extraContentClassName={styles.extraClass}
					wrapperClass={styles.contentWrapper}
				/>
			}
			content={newsToOpen &&
				<NewsContent
					item={newsToOpen}
					lang={lang}
				/>
			}
			extraClassName={cs(styles.fixHeight, styles.fixMobileContent, styles.fixMobilePadding)}
		/>
	)
}
export default NewsPageDom



// WEBPACK FOOTER //
// ./elements/NewsPageDom.jsx